import { AppConfig, UserSession, showConnect, openContractCall } from '@stacks/connect';
import { StacksMainnet, StacksTestnet, StacksMocknet } from '@stacks/network';
import { CustomMapProps } from './components/lobby/CreateLobbyComponent';
import { FinishedTxData } from '@stacks/connect/dist/types/types/transactions';
import { link_comp } from './game-engine/maps-utils/constants';

import { stringAsciiCV, uintCV, FungibleConditionCode, makeStandardSTXPostCondition } from '@stacks/transactions';
import { Dispatch } from 'react';
import { logIn, logOut } from './store/userStore';
import { contractMapping } from './constants/contract';
import { Network, network } from './constants/network';
import { transactionUrl } from './constants/transactionUrl';
import { StacksNetwork } from '@stacks/network/src/index';
import { uniqueId } from 'lodash-es';

// TODO(andrei): Move this to the right files
interface ICreateTournament {
  customGameProps: CustomMapProps;
  generatedCars: number;
  generatedRoad: Array<number>;
  onFinish: (txId: any, cars: number, road: Array<number>) => void;
  onCancel: () => void;
}

interface IJoinTournament {
  id: number;
  price: number;
  onFinish: () => void;
  onCancel: () => void;
}

interface IDisassembleDegen {
  nft: string;
  price: number;
  onFinish: () => void;
  onCancel: () => void;
}

const appConfig = new AppConfig(['store_write', 'publish_data']);

export const userSession = new UserSession({ appConfig });

export function toMiliSTX(x: number) {
  return x * 1000000;
}

const StacksNetworkInitFn: Record<Network, () => StacksNetwork> = {
  mainnet: () => new StacksMainnet(),
  testnet: () => new StacksTestnet(),
  mocknet: () => new StacksMocknet(),
};

const networkParam = StacksNetworkInitFn[network]();

let HackySolution = 'unique';

function nextUniqueId() {
  const result = uniqueId();
  HackySolution = result;
  return HackySolution;
}

// TODO(#42): refactor
export function createTournament(props: ICreateTournament) {
  let { customGameProps, generatedCars, generatedRoad, onFinish: onFinishParsed, onCancel: onCancelParsed } = props;
  let { map, length, traffic, curves, price, hours, description } = customGameProps;

  const currentUserAddress = JSON.parse(localStorage.getItem('userData') as string);
  const DefaultContractParams = {
    commission: 10,
    factor: 3,
  };
  const functionArgs = [
    stringAsciiCV(description),
    uintCV(toMiliSTX(price)), // in millistx because that amount is transfered
    uintCV(DefaultContractParams.factor),
    uintCV(DefaultContractParams.commission),
    stringAsciiCV(map),
    stringAsciiCV(length),
    stringAsciiCV(traffic),
    stringAsciiCV(curves),
    uintCV(hours),
  ];

  const standardFungiblePostCondition = makeStandardSTXPostCondition(
    currentUserAddress,
    FungibleConditionCode.LessEqual,
    toMiliSTX(price)
  );

  const degenTransactionId = nextUniqueId();

  const options = {
    contractAddress: contractMapping[network].contract.split('.')[0],
    contractName: contractMapping[network].contract.split('.')[1],
    functionName: contractMapping[network].createLobby,
    functionArgs: functionArgs,
    network: networkParam,
    postConditions: [standardFungiblePostCondition],
    appDetails: {
      name: 'Create Lobby',
      icon: 'https://stacksdegens.com' + '/logo.png',
    },
    onFinish: (data: FinishedTxData) => {
      if (degenTransactionId !== HackySolution) {
        console.log('This got dropped');
        return;
      }
      onFinishParsed(data.txId, generatedCars, generatedRoad);
      console.log('success. view transaction on api: ', transactionUrl[network](data.txId).apiUrl);
    },
    onCancel: () => {
      // setLoadingState() // todo: call to update state of lobby creation to 'canceled'
      onCancelParsed();
      console.log('canceled');
    },
  };
  openContractCall(options);
}

// TODO(#42): refactor
export function joinTournament(props: IJoinTournament) {
  let { id, price, onFinish: onFinishParsed, onCancel: onCancelParsed } = props;
  const currentUserAddress = JSON.parse(localStorage.getItem('userData') as string);

  const functionArgs = [uintCV(id)];

  const standardFungiblePostCondition = makeStandardSTXPostCondition(
    currentUserAddress,
    FungibleConditionCode.LessEqual,
    toMiliSTX(price)
  );

  const options = {
    contractAddress: contractMapping[network].contract.split('.')[0],
    contractName: contractMapping[network].contract.split('.')[1],
    functionName: contractMapping[network].joinLobby,
    functionArgs: functionArgs,
    network: networkParam,
    postConditions: [standardFungiblePostCondition],
    appDetails: {
      name: 'Join Lobby',
      icon: 'https://stacksdegens.com' + '/logo.png',
    },
    onFinish: (data: FinishedTxData) => {
      console.log('success. view transaction on api: ', transactionUrl[network](data.txId).apiUrl);
      onFinishParsed();
    },
    onCancel: () => {
      onCancelParsed();
      console.log('canceled');
    },
  };
  openContractCall(options);
}

export function disassembleDegen(props: IDisassembleDegen) {
  let { nft, price, onFinish: onFinishParsed, onCancel: onCancelParsed } = props;
  const currentUserAddress = JSON.parse(localStorage.getItem('userData') as string);

  const functionArgs = [uintCV(nft)];

  const standardFungiblePostCondition = makeStandardSTXPostCondition(
    currentUserAddress,
    FungibleConditionCode.LessEqual,
    toMiliSTX(price)
  );

  const options = {
    contractAddress: contractMapping[network].contract.split('.')[0],
    contractName: contractMapping[network].contract.split('.')[1],
    functionName: contractMapping[network].joinLobby,
    functionArgs: functionArgs,
    network: networkParam,
    postConditions: [standardFungiblePostCondition],
    appDetails: {
      name: 'Disassemble Degen',
      icon: 'https://stacksdegens.com' + '/logo.png',
    },
    onFinish: (data: FinishedTxData) => {
      console.log('success. view transaction on api: ', transactionUrl[network](data.txId).apiUrl);
      onFinishParsed();
    },
    onCancel: () => {
      onCancelParsed();
      console.log('canceled');
    },
  };
  openContractCall(options);
}

export function authenticate(dispatch: Dispatch<any>) {
  showConnect({
    appDetails: {
      name: 'Stacks Degens Racing',
      icon: 'https://stacksdegens.com' + '/logo.png',
    },
    redirectTo: '/',
    onFinish: () => {
      let userData = userSession.loadUserData();
      // mocknet address is the same with the tesnet address -> only testnet is stored
      const network_pick: Network = network === 'mainnet' ? 'mainnet' : network == 'testnet' ? 'testnet' : 'testnet';
      let wallet = JSON.stringify(userData.profile.stxAddress[network_pick]);
      localStorage.setItem('userData', wallet);

      dispatch(logIn(wallet));

      // TODO(flow) get rid of all window.location manipulation
      window.location.reload();
    },
    userSession: userSession,
  });
}

// TODO(#41): remove localstorage
export function completeSignOut(dispatch: Dispatch<any>) {
  localStorage.removeItem('nrNFT');
  localStorage.removeItem('collection');
  localStorage.removeItem('userData');
  localStorage.removeItem('miami-degens-owned');
  localStorage.removeItem('nyc-degens-owned');
  localStorage.removeItem('SDGU-stacks-punks-owned');
  localStorage.removeItem('nrSelected');
  localStorage.removeItem('fast_lap_time');
  userSession.signUserOut();

  dispatch(logOut());

  // TODO(flow) get rid of all window.location manipulation
  window.location = link_comp as any;
}
